import {combineReducers} from 'redux';

import {routerReducer} from 'react-router-redux';
import {reducer as formReducer} from 'redux-form';

import channels from '../ducks/channels';
import taxons from '../ducks/taxons';
import products from '../ducks/products';
import eventProducts from '../ducks/eventProducts';
import cart from '../ducks/cart';
import menus from '../ducks/menus';
import pages from '../ducks/pages';
import search from '../ducks/search';
import ui from '../ducks/ui';
import misc from '../ducks/misc';

const rootReducer = combineReducers({
  channels,
  taxons,
  products,
  eventProducts,
  cart,
  menus,
  pages,
  search,
  ui,
  misc,
  routing: routerReducer,
  form: formReducer
});

export default rootReducer;



// WEBPACK FOOTER //
// ./store/rootReducer.js